export const GOOGLE_TRANSLATE_EXTENSION_NAME = 'Google Translate';
export const GOOGLE_TRANSLATE_CLASS_NAMES = ['translated-ltr', 'translated-rtl'];
